import React from "react";
import FieldError from "../registration/FieldError";

function EmissionQuestionsSection({
  language,
  questionsEmissions1,
  setQuestionsEmissions1,
  questionsEmissions2,
  setQuestionsEmissions2,
  questionsEmissions3,
  setQuestionsEmissions3,
  requiresScope,
  setStoredValue,
  formErrors,
}) {
  const t = {
    EN: {
      measuring: "Does your company currently measure its greenhouse gas emissions? (optional)",
      scope: "What emissions scope are you considering in your management? (optional)",
      challenge: "What is your biggest challenge today for managing emissions? (optional)",
      selectOption: "Select an option",
      yes: "Yes",
      inProgress: "In progress",
      no: "No",
      unknown: "I don't know",
      scope1: "Direct only - Scope 1",
      scope12: "Direct and indirect - Scope 1 and 2",
      scope123: "Scopes 1, 2 and 3",
      time: "Lack of time and investment",
      tools: "Lack of tools",
      agenda: "It is not on the agenda",
    },
    ES: {
      measuring: "¿Tu empresa mide actualmente sus emisiones de Gases de Efecto Invernadero? (opcional)",
      scope: "¿Qué alcance de emisiones están considerando en su gestión? (opcional)",
      challenge: "¿Cuál es hoy su mayor desafío para gestionar emisiones? (opcional)",
      selectOption: "Seleccioná una opción",
      yes: "Sí",
      inProgress: "En proceso",
      no: "No",
      unknown: "No lo sé",
      scope1: "Sólo directas - Alcance 1",
      scope12: "Directas e indirectas - Alcance 1 y 2",
      scope123: "Alcances 1, 2 y 3",
      time: "Falta de tiempo e inversión",
      tools: "Falta de herramientas",
      agenda: "No está en la agenda",
    },
  };

  return (
    <>
      <div className="containerFlex">
        <div className="col-2">
          <label>
            {t[language].measuring}
          </label>
          <select
            value={questionsEmissions1}
            name="questions_emissions_1"
            onChange={(e) => {
              const value = e.target.value;
              setQuestionsEmissions1(value);
              setStoredValue("questions_emissions_1", value);

              if (value !== "Sí" && value !== "En proceso") {
                setQuestionsEmissions2("");
                setStoredValue("questions_emissions_2", "");
              }
            }}
          >
            <option value="" disabled>
              {t[language].selectOption}
            </option>
            <option value="Sí">{t[language].yes}</option>
            <option value="En proceso">{t[language].inProgress}</option>
            <option value="No">{t[language].no}</option>
            <option value="No lo sé">{t[language].unknown}</option>
          </select>
          <FieldError error={formErrors.questionsEmissions1} />
        </div>

        <div className="col-2">
          <label>
            {t[language].scope}
          </label>
          <select
            value={questionsEmissions2}
            name="questions_emissions_2"
            onChange={(e) => {
              const value = e.target.value;
              setQuestionsEmissions2(value);
              setStoredValue("questions_emissions_2", value);
            }}
            disabled={!requiresScope}
          >
            <option value="" disabled>
              {t[language].selectOption}
            </option>
            <option value="Alcance 1">{t[language].scope1}</option>
            <option value="Alcance 1 y 2">{t[language].scope12}</option>
            <option value="Alcances 1, 2 y 3">{t[language].scope123}</option>
            <option value="No lo sé">{t[language].unknown}</option>
          </select>
          <FieldError error={formErrors.questionsEmissions2} />
        </div>
      </div>

      <div className="containerFlex">
        <div className="col-2">
          <label>
            {t[language].challenge}
          </label>
          <select
            value={questionsEmissions3}
            name="questions_emissions_3"
            onChange={(e) => {
              const value = e.target.value;
              setQuestionsEmissions3(value);
              setStoredValue("questions_emissions_3", value);
            }}
          >
            <option value="" disabled>
              {t[language].selectOption}
            </option>
            <option value="Falta de tiempo e inversión">{t[language].time}</option>
            <option value="Falta de herramientas">{t[language].tools}</option>
            <option value="No está en la agenda">{t[language].agenda}</option>
            <option value="No lo sé">{t[language].unknown}</option>
          </select>
          <FieldError error={formErrors.questionsEmissions3} />
        </div>
      </div>
    </>
  );
}

export default EmissionQuestionsSection;
